import HomeIcon from "@mui/icons-material/Home";
import { Box, IconButton, Stack, Grid, Typography } from "@mui/material";
import LoginImage from "../../Images/LoginImage.png";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../Images/fifyPluslogo.png";
import NaranjoLogo from "../../Images/JCH-logo-cropped.png";
import { styled } from "@mui/system";
import { Tabs } from "@mui/base/Tabs";
import { TabsList as BaseTabsList } from "@mui/base/TabsList";
import { TabPanel as BaseTabPanel } from "@mui/base/TabPanel";
import { buttonClasses } from "@mui/base/Button";
import { Tab as BaseTab, tabClasses } from "@mui/base/Tab";
import JobseekerSignUp from "../SignUp/JobseekerSignUp";
import EmployerSignup from "../SignUp/EmployerSignup.jsx";
import { useEffect, useState } from "react";
import Group1526 from "../../Images/Group 1526.png";
import { useSelector } from "react-redux";

export default function Signup() {
  const redirect = useNavigate();
  const Labels = useSelector((state) => state.allLabels.labels);

  return (
    <Grid container direction="row" sx={{ minHeight: "100vh" }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          background:
            "linear-gradient(145deg, #fff8ec 0%, #dff3ed 52%, #d2f0ff 100%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          minHeight: "100vh",
          overflowY: "auto",
          py: { xs: 3, md: 4 },
        }}
      >
        <Stack width="100%">
        <Stack direction="row" justifyContent="flex-end" sx={{display: { xs: 'flex', md: 'none' },}}>
          <IconButton
            sx={{
              color: "#136E9B",
              height: "100%",
              background: "rgba(0, 0, 0, 0.04)"
            }}
            aria-label="delete"
            onClick={() => redirect("/landingpage")}
          >
            <HomeIcon />
          </IconButton>
        </Stack>
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2.5}
            sx={{ boxSizing: "border-box", px: 2, width: "100%" }}  
          >
            <Box
              onClick={() => redirect("/landingpage")}
              sx={{
                cursor: "pointer",
                textAlign: "center",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  background: "#fff",
                  border: "1px solid rgba(19, 110, 155, 0.18)",
                  borderRadius: "14px",
                  boxShadow: "0 18px 45px rgba(69, 38, 12, 0.14)",
                  display: "inline-flex",
                  p: 1.5,
                }}
              >
                <Box
                  component="img"
                  src={NaranjoLogo}
                  alt="Jacob's Coffee House"
                  sx={{
                    height: { xs: 78, md: 92 },
                    objectFit: "contain",
                    width: { xs: 108, md: 128 },
                  }}
                />
              </Box>
              <Typography
                variant="h5"
                sx={{ color: "#4b2a14", fontWeight: 700, mt: 1.5 }}
              >
                Jacob's Coffee House
              </Typography>
              <Typography sx={{ color: "#136E9B", fontWeight: 500, mt: 0.5 }}>
                Create your account
              </Typography>
            </Box>
            <Box sx={{ width: "100%", maxWidth: 600, px: { xs: 0, sm: 2 } }}>
              <Tabs defaultValue={1}>
                <TabsList>
                  <Tab value={1}>{Labels?.JobSeeker}</Tab>
                  <Tab value={2}>{Labels?.Employer}</Tab>
                </TabsList>
                <TabPanel value={1}>
                  <JobseekerSignUp />
                </TabPanel>
                <TabPanel value={2}>
                  <EmployerSignup />
                </TabPanel>
              </Tabs>
            </Box>
          </Stack>
        </Stack>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: { xs: "none", md: "flex" },
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: "100vh",
        }}
      >
        <Stack direction="row" justifyContent="flex-end">
          <IconButton
            sx={{
              color: "#136E9B",
              height: "100%",
              background: "rgba(0, 0, 0, 0.04)",
            }}
            aria-label="delete"
            onClick={() => redirect("/landingpage")}
          >
            <HomeIcon />
          </IconButton>
        </Stack>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          sx={{ flex: 1, mt: -8 }}
        >
          <Grid item>
            <img
              src={Group1526}
              className="loginImg"
              alt="loginImage"
              style={{
                height: "100%",
                width: "100%",
                objectFit: "contain",
              }}
            />
          </Grid>
          <Grid item>
            <Typography
              variant="h5"
              align="center"
              sx={{ mt: 2, color: "#136E9B", fontWeight: 600, fontSize: 20 }}
            >
              <Box component="span">{Labels?.FindYourDreamJobiNOnePlace	}</Box>
              
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#136E9B",
};

const Tab = styled(BaseTab)`
  font-family: "IBM Plex Sans", sans-serif;
  color: #fff;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  background-color: transparent;
  width: 100%;
  padding: 12px 14px;
  margin: 0;
  border: none;
  border-radius: 0;
  display: flex;
  justify-content: center;
  min-height: 44px;
  &:focus {
    outline: none;
  }

  &.${tabClasses.selected} {
    background-color: #fff;
    color: #136e9b;
    box-shadow: inset 0 -3px 0 #136e9b;
  }

  &.${buttonClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TabPanel = styled(BaseTabPanel)(
  ({ theme }) => `
  width: 100%;
  box-sizing: border-box;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
  padding: 24px 28px;
  background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  border: 1px solid rgba(19, 110, 155, 0.24);
  border-top: 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  @media (max-width: 600px) {
    padding: 20px 16px;
  }
  `
);

const TabsList = styled(BaseTabsList)(
  ({ theme }) => `
  width: 100%;
  overflow: hidden;
  background-color: #53605d;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
  box-shadow: 0 12px 28px ${
    theme.palette.mode === "dark" ? grey[900] : grey[200]
  };
  `
);
